<template>
  <b-modal
    id="editPolicyBrokerModal"
    title="Modifica Produttore"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-backdrop
  >
    <template v-slot:modal-header-close>
      <base-icon name="close" width="14" height="14"></base-icon>
    </template>
    <div class="text-center my-4" v-if="!ok">
      <div class="custom-loader"></div>
      <p>Operazione in corso...</p>
    </div>
    <div class="mt-2" v-else>
      <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="">
          <div class="form-group">
            <base-select
              name="broker_id"
              vid="broker_id"
              label="Produttore"
              v-model="form.insurance_policy.broker_id"
              :options="broker_options"
              :rules="getRules('broker_id', 'insurance_policy')"
            />
          </div>
          <div class="py-2 mb-4 d-flex justify-content-end">
            <b-button
              @click="handleSubmit(onSubmit)"
              type="button"
              :disabled="invalid"
              variant="lisaweb"
              size="sm"
            >
              Salva
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";
import BaseSelect from "@/components/form/BaseSelect";
import BaseIcon from "@/components/BaseIcon";
import { mapGetters } from "vuex";

export default {
  name: "EditPolicyBrokerModal",
  mixins: [FormMixin],
  components: {
    BaseSelect,
    BaseIcon,
  },
  data() {
    return {
      repository: "insurance_policy",
      policyId: null,
      broker_options: [],
    };
  },
  mounted() {
    this.broker_options = this.getSalesmen();
  },
  methods: {
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
    }),
    show(item) {
      this.policyId = item.id;
      this.ok = false;
      this.$bvModal.show("editPolicyBrokerModal");
      this.fetchEditForm("insurance_policy", item.id);
    },
    onSubmit() {
      this.ok = false;
      this.update("insurance_policy", this.policyId)
        .then(() => {
          this.$bvModal.hide("editPolicyBrokerModal");
          this.$showSnackbar({
            preset: "success",
            text: "Produttore modificato con successo",
          });
          this.$emit("updated");
        })
        .catch((error) => {
          this.ok = true;
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.modal-body:has(.multiselect--active)) {
  min-height: 450px;
}
</style>
